import React from "react";
interface PropsData {
  fillColor: string;
}
const DashboardIcon = (props: PropsData) => {
  return (
    <div className="me-1">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.6155 20C5.15517 20 4.77083 19.8458 4.4625 19.5375C4.15417 19.2292 4 18.8448 4 18.3845V5.6155C4 5.15517 4.15417 4.77083 4.4625 4.4625C4.77083 4.15417 5.15517 4 5.6155 4H18.3845C18.8448 4 19.2292 4.15417 19.5375 4.4625C19.8458 4.77083 20 5.15517 20 5.6155V18.3845C20 18.8448 19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8448 20 18.3845 20H5.6155ZM5.6155 19H11.5V5H5.6155C5.4615 5 5.32042 5.06408 5.19225 5.19225C5.06408 5.32042 5 5.4615 5 5.6155V18.3845C5 18.5385 5.06408 18.6796 5.19225 18.8078C5.32042 18.9359 5.4615 19 5.6155 19ZM12.5 19H18.3845C18.5385 19 18.6796 18.9359 18.8078 18.8078C18.9359 18.6796 19 18.5385 19 18.3845V12H12.5V19ZM12.5 11H19V5.6155C19 5.4615 18.9359 5.32042 18.8078 5.19225C18.6796 5.06408 18.5385 5 18.3845 5H12.5V11Z"
          fill={props?.fillColor}
          stroke={props?.fillColor}
        />
      </svg>
    </div>
  );
};
export default DashboardIcon;
